import { useQuery } from '@apollo/client';
import { Table, Descriptions } from 'antd';
import moment from 'moment';
import { useContext, useState, useEffect } from 'react';
import { PageContext } from '../../../lib/context';
import queries from '../../../utils/gql/queries';
import GoogleMapReact from 'google-map-react';

interface MeterReading {
  id: number;
  value: number;
  date_time: Date;
}
interface MeterReading {
  id: number;
  value: number;
  date_time: Date;
  date_added: Date;
}

const ReadingTable = () => {
  const { form, _submitHandler, selectedMeter } = useContext(PageContext);
  const [meter_readings, setMeterReadings] = useState<Array<any>>([]);
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Value',
      dataIndex: 'value',
      key: 'value',
    },
    {
      title: 'Date',
      dateIndex: 'date_time',
      key: 'date_time',
      render: (_: any, record: { key: React.Key; date_time: any }) => {
        return moment(record.date_time).format('LLL');
      },
    },
  ];
  const { data, loading, error } = useQuery(queries.GET_METER_READING, {
    variables: {
      serial_id: selectedMeter?.serial_number ?? 0,
    },
    fetchPolicy: 'no-cache',
  });

  const [defaultCenter, setDefaultCenter] = useState({
    lat: 10.58869,
    lng: 124.01552,
  });

  const [zoom, setZoom] = useState(20);

  useEffect(() => {
    if (!loading && data) {
      setMeterReadings(data.meter_readings);
    }
  }, [data]);

  useEffect(() => {
    if (selectedMeter.latitude && selectedMeter.longitude) {
      setDefaultCenter({
        lat: selectedMeter.latitude,
        lng: selectedMeter.longitude,
      });
    }
    setZoom(20);
  }, [selectedMeter]);

  const defaultProps = {
    center: {
      lat: 10.58869,
      lng: 124.01552,
    },
    zoom: 20,
  };

  const Marker = (props: any) => {
    return <div className="w-5 h-5 bg-yellow-600 rounded-full"></div>;
  };

  return (
    <div className="flex flex-col px-50">
      <Descriptions column={1} bordered>
        <Descriptions.Item label="Meter ID">
          {selectedMeter?.serial_number}
        </Descriptions.Item>
        <Descriptions.Item label="Name">
          {`${selectedMeter?.subscriber_info?.first_name} ${selectedMeter?.subscriber_info?.last_name}`}
        </Descriptions.Item>
        <Descriptions.Item label="Address">
          {`${selectedMeter?.subscriber_info?.complete_address}`}
        </Descriptions.Item>
      </Descriptions>

      <div className="w-full bg-blue-400" style={{ height: 300 }}>
        <GoogleMapReact
          bootstrapURLKeys={{
            key: 'AIzaSyDSQ7BgmenncMg89GCFV20_GBCAJ1K15FU',
          }}
          center={defaultCenter}
          defaultCenter={defaultProps.center}
          defaultZoom={defaultProps.zoom}
          zoom={zoom}
          yesIWantToUseGoogleMapApiInternals
          // options={{ mapTypeId: mapRef.current.MapTypeId.SATELLITE }}
          options={(map: any) => ({ mapTypeId: map.MapTypeId.HYBRID })}
        >
          {selectedMeter?.latitude && (
            <Marker
              lat={selectedMeter.latitude}
              lng={selectedMeter.longitude}
            />
          )}
        </GoogleMapReact>
      </div>

      <div className="flex flex-row mt-10">
        <div className="w-full mr-3">
          <Table dataSource={meter_readings} columns={columns} bordered />
        </div>
      </div>
    </div>
  );
};

export default ReadingTable;
